import { BottomNavigation, BottomNavigationAction, Box, Container, Paper, Stack, TextareaAutosize } from "@mui/material";
import { LogementPageOutletContext, ViewKind } from "../LogementPageBase";
import { LogementDivider } from "./LogementTabContent";
import { useNavigate, useOutletContext } from "react-router";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";

export interface CommentsTabContentProps {
    readonly viewKind: ViewKind;
}

export const CommentsTabContent = (props: CommentsTabContentProps) => {
    const { logementAccessor } = useOutletContext() as LogementPageOutletContext;
    const chemExtInfo = logementAccessor.chemExtInfo;
    const communInfo = logementAccessor.communInfo;
    const logementInfo = logementAccessor.logementInfo;
    const statioInfo = logementAccessor.statioInfo;
    const navigate = useNavigate();
    const goToNext = () => {
        navigate("../documents");
    };
    const goToPrevious = () => {
        navigate("../diagnostic");
    };
    return (<Box sx={{ pb: 7 }}><Stack spacing={1}>
        <LogementDivider text="Cheminements extérieurs"/>
        <TextareaAutosize
            disabled={props.viewKind === ViewKind.Read}
            minRows={5}
            value={chemExtInfo?.get() ?? ""}
            onChange={(ev) => chemExtInfo?.set(ev.target.value)}
            style={{width: "100%", resize: "none"}}
        />
        <LogementDivider text="Parties communes"/>
        <TextareaAutosize
            disabled={props.viewKind === ViewKind.Read}
            minRows={5}
            value={communInfo?.get() ?? ""}
            onChange={(ev) => communInfo?.set(ev.target.value)}
            style={{width: "100%", resize: "none"}}
        />
        <LogementDivider text="Logement"/>
        <TextareaAutosize
            disabled={props.viewKind === ViewKind.Read}
            minRows={5}
            value={logementInfo?.get() ?? ""}
            onChange={(ev) => logementInfo?.set(ev.target.value)}
            style={{width: "100%", resize: "none"}}
        />
        <LogementDivider text="Stationnement"/>
        <TextareaAutosize
            disabled={props.viewKind === ViewKind.Read}
            minRows={5}
            value={statioInfo?.get() ?? ""}
            onChange={(ev) => statioInfo?.set(ev.target.value)}
            style={{width: "100%", resize: "none"}}
        />
    </Stack>
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
        <Container sx={{p: "1 1"}} maxWidth="md">
          <BottomNavigation
            showLabels
          >
            <BottomNavigationAction label="Précédent" icon={<NavigateBefore />} onClick={goToPrevious} />
            <BottomNavigationAction label="Suivant" icon={<NavigateNext />} onClick={goToNext} />
          </BottomNavigation>
        </Container>
      </Paper>
    </Box>);
}
